module.exports = __webpack_public_path__ + "img/51.1384d373.jpg";